import React, { useEffect, useContext, useRef } from 'react'
import { NextpageContext } from '../context/nextpage.context'

export type ITabbedProps = {
  tabList: any[]
  tabContent: any[]
}

const Tabbed = ({ tabList, tabContent }: ITabbedProps) => {
  const nextpage = useContext(NextpageContext)
  const tabbedRef = useRef(null)

  useEffect(() => {
    nextpage.UI.components.tabbed(tabbedRef.current)
  })
  const tabs = tabList.map((tl, i) => (
    <li key={i} role="tab" className={`tab ${i === 0 ? 'aria-selected' : ''}`}>
      {tl}
    </li>
  ))
  const content = tabContent.map((tc, i) => (
    <div key={i} className={`tab-content ${i === 0 ? '' : 'aria-hidden'}`} role='tabpanel'>
      {tc}
    </div>
  ))
  return (
    <React.Fragment>
      <div ref={tabbedRef} id='tabsContainer' className='tabbed' role='tablist'>
        <ul className='tabs'>{tabs}</ul>
        {content}
      </div>
    </React.Fragment>
  )
}

export default Tabbed
